export const defaultColors = [
  "#E3F2FD", // Azul bem claro (blue 50)
  "#64B5F6", // Azul sereno (blue 300)
  "#B197FC",
  "#4DABF7",
  "#FFA94D",
  "#90CAF9", // Azul leve (blue 200)
  "#1976D2", // Azul intenso (blue 700)
  "#64B5F6", // Azul sereno (blue 300)
  "#1565C0", // Azul robusto (blue 800)
  "#42A5F5", // Azul brilhante (blue 400)
  "#0D47A1", // Azul bem escuro (blue 900)
  "#1E88E5", // Azul vibrante (blue 600)
  "#BBDEFB", // Azul suave (blue 100)
  "#2196F3", // Azul padrão (blue 500)
];
